import { SERVER_API } from 'SharedDir/constants/app/endpoints';
import { IEndpointData } from 'SharedDir/declarations/shared';

export const serviceLLMUrl = `${SERVER_API}/services/llm/chat`;

export default {
  LIST: {
    method: 'GET',
    url: `${serviceLLMUrl}`,
  } as IEndpointData,
  CREATE: {
    method: 'POST',
    url: `${serviceLLMUrl}`,
  } as IEndpointData,
  DELETE: (chatId: number): IEndpointData => {
    return {
      method: 'DELETE',
      url: `${serviceLLMUrl}/${chatId}`,
    };
  },
  MESSAGE_CANCEL: (chatId: number): IEndpointData => {
    return {
      method: 'POST',
      url: `${serviceLLMUrl}/${chatId}/cancel`,
    };
  },
  MESSAGE_LIST: (chatId: number): IEndpointData => {
    return {
      method: 'GET',
      url: `${serviceLLMUrl}/${chatId}/message`,
    };
  },
  MESSAGE_CREATE: (chatId: number): IEndpointData => {
    return {
      method: 'POST',
      url: `${serviceLLMUrl}/${chatId}/message`,
    };
  },
};
